<template>
  <rate-plan-blank-form
    submit-label="Добавить тарифный план"
    :rate-plan="rate_plan"
    :errors="errors"
    form-type="add"
    @submit="processRatePlanForm"
  />
</template>

<script>
import helpers from '@/helpers'
import { addRatePlan } from '@/services/rate_plan.service'
import ratePlanBlankForm from '@/components/forms/rate_plan/RatePlanBlankForm'

export default {
  name: 'rate-plan-add-form',
  components: { ratePlanBlankForm },
  data () {
    return {
      rate_plan: {
        id: null,
        name: '',
        amount: '',
        period: ''
      },

      errors: {
        rate_plan: {
          id: [],
          name: [],
          amount: [],
          period: []
        },
        non_field_errors: []
      }
    }
  },
  methods: {
    fillErrors: helpers.fillErrors,

    processRatePlanForm () {
      this.addRatePlan().then((success) => {
        if (success) {
          this.showMsg('Тарифный план был успешно добавлен!', 'success', 'Успешно')
          this.$emit('after', true)
        } else {
          this.$emit('after', false)
        }
      })
    },
    addRatePlan () {
      return addRatePlan(this.rate_plan).then((response) => {
        this.rate_plan = response.data
        this.fillErrors(this.errors.rate_plan, {})
        return true
      }).catch(err => {
        this.fillErrors(this.errors.rate_plan, err.response.data)

        if (this.errors.non_field_errors[0]) {
          this.$parent.$parent.showPopupMsg(this.errors.non_field_errors[0], 'error')
        }

        return false
      })
    },
    showMsg (text, type, title) {
      let foundRoot = false
      let $parent = this.$parent

      while (!foundRoot) {
        console.log($parent)
        if ($parent.$parent.$parent === undefined) {
          foundRoot = true
          $parent.showPopupMsg(text, type, title)
        } else {
          $parent = $parent.$parent
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// RatePlanAddForm.vue?1ba915ff